import { render } from "./CustomerProductGroupItemForm.vue?vue&type=template&id=6599c5d5"
import script from "./CustomerProductGroupItemForm.vue?vue&type=script&lang=js"
export * from "./CustomerProductGroupItemForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__